import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonButton, IonCard, IonCardContent, IonContent, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/shared/components/base-component/base.component';
import { IResultPageConfig } from './result-page.contracts';

const DEFAULT_SUCCESS_ANIMATION = 'assets/images/common/success.gif';
const DEFAULT_ERROR_ANIMATION = 'assets/images/common/warning-circular.svg';

@Component({
  selector: 'app-result-page',
  templateUrl: './result-page.component.html',
  styleUrls: ['./result-page.component.scss'],
  imports: [TranslatePipe, IonContent, IonHeader, IonToolbar, IonTitle, IonImg, IonButton, IonCard, IonCardContent, IonItem, IonIcon, IonLabel],
})
export class ResultPageComponent extends BaseComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private autoDismissTimer: ReturnType<typeof setTimeout> | null = null;

  config: IResultPageConfig;
  animationSrc: string;
  displayTitle: string;
  displaySubtitle: string | null;

  override ngOnInit(): void {
    super.ngOnInit();

    // Accept both new key (resultConfig) and legacy key (successConfig) for backward compat.
    const state = this.router.getCurrentNavigation()?.extras?.state;
    this.config = (state as Record<string, IResultPageConfig>)?.resultConfig ?? (state as Record<string, IResultPageConfig>)?.successConfig;

    if (!this.config) {
      this.router.navigate(['/tabs/home'], { replaceUrl: true });
      return;
    }

    const isError = this.config.type === 'error' || this.config.type === 'warning';
    this.animationSrc = this.config.animationPath ?? (isError ? DEFAULT_ERROR_ANIMATION : DEFAULT_SUCCESS_ANIMATION);

    // Resolve title: rawTitle takes precedence, then translate title key
    this.displayTitle = this.config.rawTitle ?? (this.config.title ? this.ui.translate.instant(this.config.title) : '');
    this.displaySubtitle = this.config.rawSubtitle ?? (this.config.subtitle ? this.ui.translate.instant(this.config.subtitle) : null);

    if (this.config.autoDismissMs && this.config.autoDismissMs > 0) {
      this.autoDismissTimer = setTimeout(() => this.primaryAction(), this.config.autoDismissMs);
    }
  }

  override ngOnDestroy(): void {
    if (this.autoDismissTimer) clearTimeout(this.autoDismissTimer);
    super.ngOnDestroy();
  }

  primaryAction(): void {
    this.router.navigate([this.config?.primaryAction?.route ?? '/tabs/home'], { replaceUrl: true });
  }

  secondaryAction(): void {
    if (this.config?.secondaryAction?.route) {
      this.router.navigate([this.config.secondaryAction.route], { replaceUrl: true });
    }
  }
}
